import React, { useState } from 'react';
import { LineChart } from 'lucide-react';
import { InfoBox, InputGroup, fmtCur } from '../Common';

const MCEquityTool = () => {
    const [cap, setCap] = useState(1000000);
    const [wr, setWr] = useState(45);
    const [aw, setAw] = useState(15);
    const [al, setAl] = useState(10);
    const [ls, setLs] = useState(65);
    const [l, setL] = useState(4);
    const [t, setT] = useState(750);

    let best = 0; let worst = Infinity; let tot = 0;
    let vpp = ls * l;
    let wr_dec = wr / 100;
    for (let sim = 0; sim < 50; sim++) {
        let eq = cap;
        for (let i = 0; i < t; i++) {
            if (Math.random() < wr_dec) eq += aw * vpp; else eq -= al * vpp;
        }
        if (eq > best) best = eq; if (eq < worst) worst = eq; tot += eq;
    }

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Monte Carlo Simulation</div>
            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Capital" value={cap} onChange={setCap} />
                <InputGroup label="Win Rate %" value={wr} onChange={setWr} />
                <InputGroup label="Avg Win Pts" value={aw} onChange={setAw} />
                <InputGroup label="Avg Loss Pts" value={al} onChange={setAl} />
                <InputGroup label="Lot Size" value={ls} onChange={setLs} />
                <InputGroup label="Lots" value={l} onChange={setL} />
                <InputGroup label="Trades/Yr" value={t} onChange={setT} />
            </div>
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-green">
                    <div className="tct-data-row"><span className="tct-label">Median Result Equity</span><span className="tct-value big-value val-green">{fmtCur.format(tot / 50)}</span></div>
                    <div className="tct-data-row"><span className="tct-label">Best Case Equity</span><span className="tct-value val-blue">{fmtCur.format(best)}</span></div>
                    <div className="tct-data-row"><span className="tct-label">Worst Case Equity</span><span className="tct-value val-red">{fmtCur.format(worst)}</span></div>
                </div>
            </div>
            <InfoBox
                title="Monte Carlo Simulation for Trading Strategies"
                meta="Monte Carlo simulations help traders understand possible equity curves and risk scenarios for trading strategies."
                sections={[
                    { title: "Introduction", content: "Monte Carlo simulation creates thousands of possible equity curves based on probability.<br><br>This helps traders understand:<br>• best case outcomes<br>• worst case scenarios<br>• realistic expectations." },
                    { title: "Example", content: "Simulating 1000 trading paths can reveal:<br>• maximum drawdown distribution<br>• median return<br>• extreme losses." },
                    { title: "Why It Matters", content: "Monte Carlo simulation is widely used in quantitative trading." }  
                ]}
            />
        </div>
    );
};

export default MCEquityTool;
